/* eslint-disable i18next/no-literal-string */
import { IButtonStyles, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppTheme } from 'common/theme';

export const getStyles = memoizeFunction(({ semanticColors, palette }: IAppTheme, customStyles?: IButtonStyles) =>
  mergeStyleSets(
    {
      root: {
        backgroundColor: semanticColors.bodyBackground,
        borderRadius: '100%',
        flexShrink: '0 !important',
      },
      rootFocused: {
        border: `2px solid ${palette.themeDark} !important`,
        '&:after': {
          outline: 'none !important',
        },
      },
    } as IButtonStyles,
    customStyles
  )
);
